import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import GConnect from './pages/GConnect';
import Service from './pages/Service';
import Product from './pages/Product';
import Cooperate from './pages/Cooperate';
import Recruitment from './pages/Recruitment';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import AppHeader from './components/Header';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const seoTitle = t('seoTitle');
    document.title = seoTitle;

    const setMetaByName = (name: string, content: string) => {
      const element = document.querySelector(`meta[name="${name}"]`);
      if (element) {
        element.setAttribute('content', content);
      }
    };

    const setMetaByProperty = (property: string, content: string) => {
      const element = document.querySelector(`meta[property="${property}"]`);
      if (element) {
        element.setAttribute('content', content);
      }
    };

    const seoDescription = t('seoDescription');
    const seoKeywords = t('seoKeywords');
    const ogTitle = t('ogTitle');
    const ogDescription = t('ogDescription');
    const twitterTitle = t('twitterTitle');
    const twitterDescription = t('twitterDescription');

    setMetaByName('description', seoDescription);
    setMetaByName('keywords', seoKeywords);
    setMetaByProperty('og:title', ogTitle);
    setMetaByProperty('og:description', ogDescription);
    setMetaByName('twitter:title', twitterTitle);
    setMetaByName('twitter:description', twitterDescription);
    document.documentElement.lang = i18n.language || 'en';
  }, [t, i18n.language]);

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader />
      <div style={{ flex: '1 0 auto' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/hyconnect" element={<GConnect />} />
          <Route path="/service" element={<Service />} />
          <Route path="/product" element={<Product />} />
          <Route path="/cooperate" element={<Cooperate />} />
          <Route path="/recruitment" element={<Recruitment />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;